import React from 'react'
import { Translator } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'
import * as UI from 'ui'
import { WhenModelValue } from '@morningtrain/react-resources'

export default function MessageRecipient () {
  return (
    <Translator namespace='smartviews.message'>
      <UI.SpaceBetween>
        <WhenModelValue name='delivered' condition>
          <UI.Text color='green'>
            <Displays.Text name='name' />
          </UI.Text>
        </WhenModelValue>
        <WhenModelValue name='delivered' condition={false}>
          <UI.Text color='red'>
            <Displays.Text name='name' />
          </UI.Text>
        </WhenModelValue>
      </UI.SpaceBetween>
    </Translator>
  )
}
